import Vuex from 'vuex';
import options from './options';

// eslint-disable-next-line import/prefer-default-export
export const store = new Vuex.Store(options);
